import { render, staticRenderFns } from "./PurchaseEditor.vue?vue&type=template&id=8a2d78b0&"
import script from "./PurchaseEditor.vue?vue&type=script&lang=js&"
export * from "./PurchaseEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports